import {
  ADD_NEW_USER_ONBOARDING,
  SET_NEW_USER_ONBOARDING,
  SET_SAVED_SEARCHES,
} from '../actionTypes'

export const addNewUserOnboarding = (step = 1) => ({
  type: ADD_NEW_USER_ONBOARDING,
  step,
})

export const setNewUserOnboarding = step => ({
  type: SET_NEW_USER_ONBOARDING,
  step,
})

export const updateSavedSearches = savedSearches => ({
  type: SET_SAVED_SEARCHES,
  savedSearches,
})
